import {
  black,
  darkestGrey,
  grey,
  tintColorDark,
  tintColorLight,
  white,
} from './palette';
export default {
  light: {
    text: black,
    background: white,
    tint: tintColorLight,
    tabIconDefault: grey,
    tabIconSelected: tintColorLight,
    textInputBackgroundColor: white,
  },
  dark: {
    text: white,
    background: black,
    tint: tintColorDark,
    tabIconDefault: grey,
    tabIconSelected: tintColorDark,
    textInputBackgroundColor: darkestGrey,
  },
};
